import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DocumentTypes } from '@domain/model/enums/document-type/cmp-link';
import { ParametersService } from '@modules/business-accounts/services/parameters/parameters.service';
import { dateRangeValidator } from '@utils/functions/datepicker';

@Component({
  selector: 'ba-partners-list-form',
  templateUrl: './partners-list-form.component.html',
  styleUrls: ['./partners-list-form.component.scss']
})
export class PartnersListFormComponent extends DocumentTypes() implements OnInit {
  @Input() maxPartnersSize: number = 6;

  @Output() newPartnerRequest = new EventEmitter<void>();
  @Output() removePartnerRequest = new EventEmitter<number>();

  constructor(
    public readonly paramsService: ParametersService,
    private readonly controlContainer: ControlContainer
  ) {
    super();
  }
  ngOnInit(): void {
  }

  partnerList() {
    return this.controlContainer.control as FormArray;
  }

  getControls() {
    return this.partnerList().controls as FormGroup[];
  }

  getCEDataForm(partnerForm: AbstractControl) {
    return partnerForm.get('CEData') as FormGroup;
  }

  getAddressForm(ceDataForm: AbstractControl) {
    return ceDataForm.get('address') as FormGroup;
  }

  chkPepNewPepPartner(event: any, index: number) {
    const isChecked = event.target.checked;
    const partner = this.form.at(index) as FormGroup;
    if (isChecked) {
      partner.addControl(
        'pepPartnerList',
        new FormGroup({
          pepEntity: new FormControl(null),
          pepPosition: new FormControl(null),
          pepStartDate: new FormControl(null),
          pepEndDate: new FormControl(null),
        },
          [Validators.required, dateRangeValidator])
      );
    } else {
      partner.removeControl('pepPartnerList');
    }
  }

  get form() {
    return this.controlContainer.control as FormArray;
  }
}
